import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=a45a8d2c&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=a45a8d2c&prod&scoped=true&lang=scss"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=a45a8d2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45a8d2c",
  null
  
)

export default component.exports